<app-treeview #treeV *ngIf="tree" [tree]="tree" (selectedElementChanged)="selectedElementChanged.emit($event)" class="valueTree"
    (confirmSelection)="confirmSelection.emit()">
</app-treeview>
